module.exports = __webpack_public_path__ + "static/media/outlet_profile_new.6df5ad0c.svg";